const PRIVATE_FIELD =
  /^(?:authorization|cookie|set-cookie|password|code|email|access_?token|refresh_?token|id_?token|client_?secret|body|originalData)$/i;

export function sanitizeDiagnosticText(text: string): string {
  return text
    .replace(/(\/authentication\/)[^\s?#"'<>]+/gi, '$1[REDACTED]')
    .replace(/(\/password-recovery\/reset-password\/)[^\s?#"'<>]+/gi, '$1[REDACTED]')
    .replace(
      /([?&](?:code|email|token|access_token|refresh_token|id_token|payment_intent_client_secret)=)[^&#\s]*/gi,
      '$1[REDACTED]',
    )
    .replace(/Bearer\s+[^\s"'<>]+/gi, 'Bearer [REDACTED]');
}

/** Clone diagnostics so SDK-owned breadcrumbs and application objects are not mutated. */
export function sanitizeSentryPayload<T>(value: T): T {
  const seen = new WeakSet<object>();
  const visit = (entry: unknown, depth: number): unknown => {
    if (typeof entry === 'string') return sanitizeDiagnosticText(entry);
    if (!entry || typeof entry !== 'object') return entry;
    if (depth > 20 || seen.has(entry)) return '[REDACTED]';
    seen.add(entry);
    if (Array.isArray(entry)) return entry.map((item) => visit(item, depth + 1));
    return Object.fromEntries(
      Object.entries(entry).map(([key, item]) => [
        key,
        PRIVATE_FIELD.test(key) ? '[REDACTED]' : visit(item, depth + 1),
      ]),
    );
  };
  return visit(value, 0) as T;
}
